module.exports = __webpack_public_path__ + "static/media/meh_icon.5dc608f1.svg";